import type { CoprincipalAccountLink } from "owa-account-source-list-types";
import type { CoprincipalAccountSource } from "../store/schema/AccountSourceList";
import { getEasidLicensingMailboxInfo, getLinkedMsaMailboxInfo, } from "../utils/getAccountLinkMailboxInfo";

export default function getCoprincipalAccountLink(account: CoprincipalAccountSource | undefined): CoprincipalAccountLink | undefined {
    const easidLicensingMailboxInfo = getEasidLicensingMailboxInfo(account);
    if (easidLicensingMailboxInfo) {
        return { linkType: "EASID", licensingMailboxInfo: easidLicensingMailboxInfo };
    }
    
    const msaMailboxInfo = getLinkedMsaMailboxInfo(account);
    if (msaMailboxInfo) {
        return { linkType: "MSA", msaMailboxInfo };
    }
    
    return undefined;
}
